import { __assign, __read, __spreadArray } from "tslib";
import React from "react";
import classNames from "classnames";
import { View } from "@tarojs/components";
import { noop } from "../_util/noop";
import { useDefault } from "../_util/use-default";
import { CheckContext } from "../check";
export function CheckboxGroup(_a) {
    var checkValue = _a.value, _b = _a.defaultValue, defaultCheckValue = _b === void 0 ? [] : _b, _c = _a.onChange, onCheckValueChange = _c === void 0 ? noop : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, type = _a.type, block = _a.block, className = _a.className, style = _a.style, children = _a.children;
    var _e = __read(useDefault(checkValue, defaultCheckValue, onCheckValueChange), 2), value = _e[0], onChange = _e[1];
    var checkedSet = new Set(value || []);
    var context = {
        inject: function (checkProps) {
            // 只为 checkbox 提供
            if (checkProps.radio) {
                return checkProps;
            }
            // 如果已经受控，则不注入
            if (typeof checkProps.checked === "boolean") {
                return checkProps;
            }
            var checkName = checkProps.name;
            if (typeof checkName === "undefined") {
                console.warn('<Checkbox> managed by <CheckboxGroup> must include the "name" prop');
                return checkProps;
            }
            return __assign(__assign({}, checkProps), { type: type,
                block: block, checked: checkedSet.has(checkName), disabled: checkProps.disabled || disabled, onChange: function (checked, context) {
                    // 支持 checkbox 上的 onChange 处理时阻止默认的处理行为
                    if (typeof checkProps.onChange === "function") {
                        checkProps.onChange(checked, context);
                        return;
                    }
                    if (typeof onChange === "function") {
                        var newValue = checked
                            ? __spreadArray(__spreadArray([], __read(value)), [checkName]) : (checkedSet.delete(checkName), Array.from(checkedSet));
                        onChange(newValue, context);
                    }
                } });
        },
    };
    return (React.createElement(View, { className: classNames("tea-checkbox-group", className, {
            "tea-checkbox-group--outline": type === "button",
        }), style: style },
        React.createElement(CheckContext.Provider, { value: context }, children)));
}
//# sourceMappingURL=CheckboxGroup.js.map